import React, { Component, PropTypes } from 'react';
import Circle from './Circle';
import Flow from './Flow';
import config from '../../config/bubbles.json';

class Bubbles extends Component {
	constructor (props) {
    	super(props);
		this.units = props.units;
		this.flows = props.flows;
		this.status = props.status;
		this.width = props.width;
		this.height = props.height;

		this.config = config;
		this.showInfo = this.props.toggleInfoHandler;
	}

	showUnitInfo(unit) {
		this.showInfo(unit, this.config.units[unit.id].colors.primary);
	}

  render() {
    return (
      	<svg width={this.width} height={this.height}>
		  <defs>
		    <filter id="f1" x="0" y="20">
		      <feGaussianBlur in="SourceGraphic" stdDeviation="1" />
		    </filter>
		  </defs>
      	{this.flows.map(flow => (

		  <Flow 
		  	key={flow.id}
		  	title={flow.title}
		  	min={flow.min}			
		  	max={flow.max}			
		  	cur={this.props.status.flows[flow.id]}
		  	fromX={this.config.units[flow.from].locX} 
		  	fromY={this.config.units[flow.from].locY} 
		  	fromColor={this.config.units[flow.from].colors.primary} 
		  	toX={this.config.units[flow.to].locX} 
		  	toY={this.config.units[flow.to].locY} 
		  	toColor={this.config.units[flow.to].colors.primary} 
		  />
		  ))}
      	{this.units.map(unit => (
		  <Circle 
		  	key={unit.id}
		  	title={unit.headline}
		  	min={unit.min}			
		  	max={unit.max}			
		  	headlinePos={unit.headlinePos}			
		  	cur={this.props.status.units[unit.id]}
		  	locX={this.config.units[unit.id].locX} 
		  	locY={this.config.units[unit.id].locY} 
		  	radius={this.config.units[unit.id].radius}
		  	colors={this.config.units[unit.id].colors}
		  	onClick={() => this.showUnitInfo(unit)}
		  	showLegend={this.props.showLegend}
		  	pulse={this.props.status.pulses[unit.id]}
		  />	
		  
      	))}
		</svg>
     );
  }
}

Bubbles.propTypes = {
	units: PropTypes.array.isRequired,
	flows: PropTypes.array.isRequired,
	width: PropTypes.number.isRequired,
	height: PropTypes.number.isRequired
};

Bubbles.defaultProps = {
	width: 1500,
	height: 1200
};

export default Bubbles;


// WEBPACK FOOTER //
// ./src/views/Bubbles/index.jsx